import Location from 'utils/Location';
import anaUtils from 'analytics/utils';
import anaConsts from 'analytics/constants';
import helpersUtils from 'utils/Helpers';
import * as pdpAnalytics from 'analytics/productPage/pdpAnalytics';

const { deferTaskExecution } = helpersUtils;

export const getComponentTitle = () => anaConsts.PAGE_TYPES.SIMILAR_PRODUCTS;

const trackProductClickAnalytics = (sku, index, podId, isCarousel) => {
    const componentTitle = getComponentTitle();
    const clickedProduct = Number(index) + 1;
    const internalCampaign = `${componentTitle?.toLowerCase()}:product`;

    const nextPageData = {
        recInfo: {
            isExternalRec: !!podId,
            componentTitle,
            podId
        },
        linkData: `${internalCampaign} ${clickedProduct}`,
        internalCampaign,
        ...(isCarousel && { events: [anaConsts.Event.EVENT_269] })
    };

    anaUtils.setNextPageData(nextPageData);

    pdpAnalytics.trackSelectItem({
        data: {
            listName: componentTitle?.toLowerCase() || '',
            listId: '',
            productId: sku?.productId?.toLowerCase() || '',
            price: sku?.listPrice || '',
            brandName: sku?.brandName || '',
            productName: sku?.productName || '',
            productIndex: index || 0
        }
    });
};

export const handleProductClick = (e, sku, index, podId, isCarousel) => {
    e.preventDefault();

    deferTaskExecution(() => {
        trackProductClickAnalytics(sku, index, podId, isCarousel);
    });

    Location.navigateTo(e, sku.targetUrl);
};
